import { Component } from '@angular/core';
import { ModalService } from '../../../../../../../coverpath-common/angular/services/modal/modal.service';
import { AmorphicService } from '../../../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { ModalType } from '../../../../../../../coverpath-common/js/interfaces/CoverpathTypes';
import { AbstractSplitModalComponent } from '../abstract-split-modal/abstract-split-modal.component';

@Component({
  selector: 'contact-widget-split',
  moduleId: module.id,
  templateUrl: './contact-update-split.component.html',
})
export class ContactUpdateComponentCoverpathSplit extends AbstractSplitModalComponent {
  policyType: string;

  constructor(amorphicService: AmorphicService, modalService: ModalService) {
    super(amorphicService, modalService);
  }

  ngOnInit(): void {}

  submitJointDecision() {
    this.modalService.deactivate();
    this.modalService.activate({ type: ModalType.contactWidget, policyType: this.policyType });
  }

  setSelection(policyType: string) {
    this.policyType = policyType;
  }

  valueSelected() {
    return !!this.policyType;
  }

  exit() {
    this.modalService.deactivate();
  }
}
